<template>
  <footer class="footer">
    <div class="container">
      <div class="footer__row">
        <div class="footer__logo docdoc">
          <router-link :to="{ path: '/' }">
            <img src="@/assets/images/logo.svg" alt="logo DocDocPro" />
          </router-link>
        </div>
        <div class="menu-footer">
          <ul class="menu-footer-items">
            <li>
              <label  class="menu-footer-item">Nos Sites</label>
            </li>
            <li>
              <a href="https://www.concourspluripro.fr/" target="_blank" class="menu-footer-item">concourspluripro.fr</a>
            </li>
            <li>
              <a href="https://www.larevuedupraticien.fr/" target="_blank" class="menu-footer-item">larevuedupraticien.fr</a>
            </li>
            <li>
              <a href="https://www.egora.fr/" target="_blank" class="menu-footer-item">egora.fr</a>
            </li>
            <li>
              <a href="https://www.globalmediasante.fr/" target="_blank" class="menu-footer-item">gmsante.fr</a>
            </li>
            <li>
              <a href="https://www.jnmg.org/" target="_blank" class="menu-footer-item">jnmg.org</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>
  
<script>
export default {
  name: "FooterMain"
}
</script>
<style lang="scss" scope>
  @import "@/scss/helpers/mixins";
  @import "@/scss/helpers/variables";

.footer {
  min-height: 96px;
  padding: 20px;
  display: flex;
  align-items: center;

  &__row{
    text-align: center;

    @include min($lg) {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      align-items: center;
      margin: auto;
      text-align: left;
    }
  }

  &__logo {
    margin: 0 0 27px;

    @include min($lg) {
      margin: 0;
    }

    img {
      width: 114px;

      @include min($lg) {
        width: 190px;
      }
    }
  }
}

.menu-footer {
  &-items {
    padding: 0;
    margin: 0;
    text-align: center;

    @include min($lg) {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
    }
  
    li {
      list-style: none;
      margin: 0 0 25px;

      @include min($lg) {
        margin: 0 21px;
      }

      a {
        font-family: $campaign;
        font-size: 12px;
        font-weight: $regular;
        text-decoration: none;
      }

      label {
        font-family: $campaign;
        font-size: 15px;
        font-weight: $bold;
      }
    }
  }
}
</style>